import React from "react";

export type ProductReasonProps = {
  title: string;
  highlight: string;
  description: string;
  reasons: { title: string; description: string }[];
};

export default function ProductReasonSection({
  title,
  highlight,
  description,
  reasons,
}: ProductReasonProps) {
  const [before, after] = title.split(highlight);

  return (
    <section className="flex flex-col gap-4 justify-center items-center">
      <span className="md:text-[45px] text-2xl text-secondary-900 font-bold text-center">
        {before}{" "}
        <span className="bg-gradient-to-r from-[#4337cc] to-primary-900 bg-clip-text text-transparent">
          {highlight}
        </span>{" "}
        {after}
      </span>
      <span className="text-center text-base md:text-xl w-full md:w-4/5">
        {description}
      </span>
      <div className="p-8 rounded-lg bg-gradient-to-br  from-purple-200 mix-blend-overlay via-[#fcfcfc]  to-[#f3d6d6] grid grid-cols-1 md:grid-cols-3 gap-10 w-full mt-10">
        {reasons.map((reason, index) => {
          return (
            <div className="flex flex-row md:flex-col gap-8" key={reason.title}>
              <span className="p-6 md:p-8 rounded-full bg-[#E7D7FD]  w-[50px] h-[50px] font-bold flex text-xl md:text-2xl justify-center items-center">
                {index + 1}
              </span>
              <div className="flex flex-col gap-4">
                <span className="text-secondary-900 font-bold text-xl md:text-2xl md:min-h-[62px]">
                  {reason.title}
                </span>
                <span className="text-secondary-900 text-base md:text-xl font-medium">
                  {reason.description}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
